import constructDataPathPrefix from './constructDataPathPrefix'

interface PathParams {
  type: string
  handle: string
  locale: string
  parentHandle?: string
}

const defaultTypes = [
  'product',
  'collection',
  'page',
  'blog',
  'article',
  'content'
]

const DELIMITER = '--'

export default (params: PathParams): string => {
  const formattedLocal = params.locale.toLowerCase().replace('_', '-')
  let path = `${params.handle}${DELIMITER}${formattedLocal}`

  if (defaultTypes.indexOf(params.type) === -1) {
    path = `${path}${DELIMITER}${params.type}`
  }

  const prefix = constructDataPathPrefix(params.type, params.parentHandle)

  return `${prefix}${path}/static.json`
}
